import React from 'react'
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom'

interface Button {
  title: string;
  url: string;
}

export default function RequestFeedButton( {title, url} : Button) {
  return (
    <NavLink 
      to={url} 
      className="py-2 px-4 font-semibold bg-lime-500 text-white rounded-sm hover:bg-lime-700"
    >{title}</NavLink>
  )
}

RequestFeedButton.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string.isRequired
};

RequestFeedButton.defaultProps = {
  title: 'Request Feed',
};